import { i18n } from "@lingui/core"

import {
    Account,
    Asset,
    Brand,
    BrandPriority,
    BrandRequisite,
    PriorityLevel,
} from "."
import { Proposal } from "components/match-proposal/model"

export enum AssetMatchesBrandRejectReason {
    TOO_SMALL = "TOO_SMALL",
    WRONG_FLOOR = "WRONG_FLOOR",
    TOO_EXPENSIVE = "TOO_EXPENSIVE",
    NOT_ENOUGH_PARKING_SLOTS = "NOT_ENOUGH_PARKING_SLOTS",
}
export class AssetMatchesBrandRejectReasonTranslations {
    TOO_SMALL = /*i18n*/i18n._({ id: "enums.match-reject-reasons.TOO_SMALL", message: "Locale/Terreno troppo piccolo" })
    WRONG_FLOOR = /*i18n*/i18n._({ id: "enums.match-reject-reasons.WRONG_FLOOR", message: "Numero di piani non adeguato" })
    TOO_EXPENSIVE = /*i18n*/i18n._({ id: "enums.match-reject-reasons.TOO_EXPENSIVE", message: "Troppo costoso" })
    NOT_ENOUGH_PARKING_SLOTS = /*i18n*/i18n._({ id: "enums.match-reject-reasons.NOT_ENOUGH_PARKING_SLOTS", message: "Parcheggi insufficienti" })
}

export enum AssetMatchesBrandStatus {
    CREATED = "CREATED",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    SENT = "SENT",
    INTERESTED = "INTERESTED",
    INSPECTION = "INSPECTION",
    CONTRACT_DONE = "CONTRACT_DONE"
}


export class AssetMatchesBrandStatusTrans {
    CREATED = /*i18n*/i18n._({id: "enums.asset-matches-brand-status.CREATED", message: "Creato"})
    APPROVED = /*i18n*/i18n._({id: "enums.asset-matches-brand-status.APPROVED", message: "Approvato"})
    REJECTED = /*i18n*/i18n._({id: "enums.asset-matches-brand-status.REJECTED", message: "Rifiutato"})
    SENT = /*i18n*/i18n._({id: "enums.asset-matches-brand-status.SENT", message: "Inviato"})
    INTERESTED = /*i18n*/i18n._({id: "enums.asset-matches-brand-status.INTERESTED", message: "Interessato"})
    INSPECTION = /*i18n*/i18n._({id: "enums.asset-matches-brand-status.INSPECTION", message: "Sopralluogo"})
    CONTRACT_DONE = /*i18n*/i18n._({id: "enums.asset-matches-brand-status.CONTRACT_DONE", message: "Contrattualizzata"})
}

export interface PartialScore {
    name: string
    description: string
    score: number
}

export interface AssetMatchBrandWithImage {
    match: AssetMatchBrand,
    image: string
    allProposals: AssetMatchBrand[]
}

export interface PropostaTimeline{
    id: string
}

export interface AssetMatchBrand {
    id: string
    asset: Asset
    brand: Brand
    visible: boolean
    partialVisible: boolean
    notes: string
    brandRequisite: BrandRequisite
    brandPriority: BrandPriority
    compatibility: number
    creationDate: Date
    lastUpdate: Date
    status: AssetMatchesBrandStatus
    rejectReason: AssetMatchesBrandRejectReason
    rejectDescription?: string | null
    partialScores?: PartialScore[]
    positivePoints?: string[]
    negativePoints?: string[]
    priorityMatch: PriorityLevel
    extra: Map<string, Object>
    proposta: Proposal
    priority: BrandPriority
}
